<adicionar-items-lista #appvaloresposiblesmodal [CaracterSeparacionRegistro]="'&'" (ConfirmoUsuario)="SeleccionoAdicionalesItem($event)"></adicionar-items-lista>

<ng-template #modalconfirmacionitems let-modal>
    <mat-dialog-content>
        <div class="modal-header text-center">
            <div class="headerm">
                <mat-icon aria-hidden="false" aria-label="Example home icon">report</mat-icon>
                <h5 class="modal-title">
                    <div [innerHTML]="TituloMostrar"></div>
                </h5>
            </div>

            <button id="confirmacion_cerrar" type="button" class="close" aria-label="Close" [mat-dialog-close]="false">
              <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="row">
                <div [formGroup]="form" fxLayout="row" fxLayoutAlign="start start" class="row pr-0 pl-0" autocomplete="off">
                    <div class="col-md-12 col-lg-12 col-12" *ngIf="!MostrarDescripcion">
                        <mat-form-field appearance="fill">
                            <mat-label>Valor adicionar</mat-label>
                            <input #itemID matInput formControlName="itemAdicionar" autocomplete="off" (keyup.enter)="AdicionarItemLista()">
                            <a matSuffix mat-icon-button (click)="AdicionarItemLista()" type="button">
                                <mat-icon>add</mat-icon>
                            </a>
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="MostrarDescripcion">
                        <mat-form-field appearance="fill">
                            <mat-label>Columna</mat-label>
                            <input #itemID matInput formControlName="itemAdicionar" autocomplete="off" (keyup.enter)="AdicionarItemLista()">
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="MostrarDescripcion">
                        <mat-form-field appearance="fill">
                            <mat-label>Descripción</mat-label>
                            <input matInput formControlName="descripcion" autocomplete="off" (keyup.enter)="AdicionarItemLista()">
                        </mat-form-field>
                    </div>
                    <div class="col-md-12 col-lg-3 col-12" *ngIf="MostrarDescripcion">
                        <a type="button" (click)="AdicionarItemLista()" class="accesoAdd">
                            <mat-icon>add</mat-icon>
                        </a>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-12">
                    <mat-list role="list">
                        <mat-list-item role="listitem" *ngFor="let item of _ListaItemsSeleccion; let i = index">
                            <a (click)="EliminarItemLista(i)" mat-icon-button matSuffix type="button">
                                <mat-icon>delete</mat-icon>
                            </a>
                            <a (click)="AbrirModificacionAdicionales(item)" mat-icon-button matSuffix type="button" *ngIf="this.AdicionarItemsPorDetalle">
                                <mat-icon>add</mat-icon>
                            </a>
                            {{DescripcionItemsLista(item)}}
                        </mat-list-item>
                    </mat-list>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
        <button id="confirmacion_no" type="button" class="btn btn-primary" [mat-dialog-close]="false">{{TextoNoMostrar}}</button>
        <button id="confirmacion_si" type="button" class="btn btn-danger" [mat-dialog-close]="true">{{TextoSiMostrar}}</button>
    </mat-dialog-actions>
</ng-template>